import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import CollapsibleContainer from "components/react-lib/generic-ui/CollapsibleContainer";
import HeaderCell from "components/table/HeaderCell";
import React from "react";

export default function FixedFees({ pricing }) {

  const formatPrice = (price) => {
    return `${price.toFixed(3)} $`;
  };

  return (
    <CollapsibleContainer
      title={"Fixed fees"}
      titleVariant="subtitle"
    >
      <Table>
        <TableBody>
          <TableRow>
            <HeaderCell align="left">Audio to text</HeaderCell>
            <TableCell align="right">
              {formatPrice(pricing.fees.audioToText)}
            </TableCell>
          </TableRow>
          <TableRow>
            <HeaderCell align="left">Text to audio</HeaderCell>
            <TableCell align="right">
              {formatPrice(pricing.fees.textToAudio)}
            </TableCell>
          </TableRow>
          <TableRow>
            <HeaderCell align="left">Message Fee</HeaderCell>
            <TableCell align="right">
              {formatPrice(pricing.fees.sendMessage)}
            </TableCell>
          </TableRow>
          <TableRow>
            <HeaderCell align="left">File Processing</HeaderCell>
            <TableCell align="right">
              {formatPrice(pricing.fees.fileProcessing)}
            </TableCell>
          </TableRow>
          <TableRow>
            <HeaderCell align="left">URL Processing</HeaderCell>
            <TableCell align="right">
              {formatPrice(pricing.fees.fileProcessing)}
            </TableCell>
          </TableRow>
          <TableRow>
            <HeaderCell align="left">Image Processing</HeaderCell>
            <TableCell align="right">
              {formatPrice(pricing.fees.imageProcessing)}
            </TableCell>
          </TableRow>
          <TableRow>
            <HeaderCell align="left">OCR</HeaderCell>
            <TableCell align="right">{formatPrice(pricing.fees.ocr)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </CollapsibleContainer>
  );
}
